module.exports = __webpack_public_path__ + "img/33d1616.jpg";